module.exports = __webpack_public_path__ + "img/signup-graphic.d3908ecc.png";